import { Component, Inject, OnInit } from '@angular/core'
import { FormBuilder, FormGroup } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { select, Store } from '@ngrx/store'
import { Destroyable, untilDestroy } from '@tokeet/tv3-platform'
import { filter, switchMapTo, take } from 'rxjs/operators'
import { LoadEntityTags, SetEntityTags } from '../store/actions'
import { uniqTags } from '../store/model'
import { isEntityTagsLoaded, selectEntityTypeTags, selectTagsEntity } from '../store/selectors'

export interface ManageEntityTagsDialogParams {
  title?: string
  type: string
  id: string
  tags?: string[]
  description?: string
}

@Component({
  selector: 'tokeet-frontend-manage-entity-tags-dialog',
  templateUrl: './manage-entity-tags-dialog.component.html',
  styleUrls: ['./manage-entity-tags-dialog.component.scss'],
  host: { class: 'modal-content' },
})
export class ManageEntityTagsDialogComponent extends Destroyable implements OnInit {
  form = this.fb.group({
    tags: [[]],
  })
  availableTags: string[] = []

  addNewTag = (tag: string) => tag

  constructor(
    public dialogRef: MatDialogRef<ManageEntityTagsDialogComponent>,
    private fb: FormBuilder,
    private store: Store<any>,
    @Inject(MAT_DIALOG_DATA) public data: ManageEntityTagsDialogParams
  ) {
    super()
  }

  ngOnInit() {
    this.store
      .pipe(
        select(isEntityTagsLoaded),
        filter((isLoaded) => isLoaded),
        switchMapTo(this.store.pipe(select(selectTagsEntity(this.data.type, this.data.id)))),
        untilDestroy(this)
      )
      .subscribe((entity) => {
        const currentValue = this.form.get('tags').value || []
        const authoritativeTags = entity && entity.pkey ? entity.tags || [] : this.data.tags || []
        this.form.patchValue({ tags: uniqTags([...authoritativeTags, ...currentValue]) })
      })

    this.store
      .pipe(select(selectEntityTypeTags(this.data.type)), untilDestroy(this))
      .subscribe((tags) => (this.availableTags = uniqTags([...tags, ...(this.data.tags || [])])))

    this.store
      .pipe(select(isEntityTagsLoaded), take(1))
      .subscribe((isLoaded) => !isLoaded && this.store.dispatch(LoadEntityTags()))
  }

  close() {
    this.dialogRef.close()
  }

  onSave(form: FormGroup) {
    const tags = uniqTags(form.getRawValue().tags || [])
    this.store.dispatch(SetEntityTags({ entityType: this.data.type, entityId: this.data.id, tags }))
    this.close()
  }
}
